import React, { useContext, useMemo } from 'react';
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
} from '@tanstack/react-table';
import { useQuery } from '@tanstack/react-query';
// import { fetchsubcriptionsalecount } from '../../pages/FleetEdge/Fleetedgekpi';
import { FilterContext } from '../../context/Filter';
import { fetchsubcriptionsalecount } from '../../pages/FleetEdge/Fleetedgekpi';

const transformData = (apiData) => {
    const yearMap = { '00': '0Y', '01': '1Y', '02': '2Y', '03': '3Y' };

    const rows = {
        upgrade: { type: 'Upgrade' },
        standard: { type: 'Standard' },
        advance: { type: 'Advance' }
    };

    Object.entries(apiData).forEach(([key, value]) => {
        const prefix = key.slice(0, 3).toLowerCase(); // upd, std, adv
        const suffix = key.slice(3);                  // 00, 01, 02, 03
        const year = yearMap[suffix];

        if (!year) return;

        if (prefix === 'upd') rows.upgrade[year] = value;
        if (prefix === 'std') rows.standard[year] = value;
        if (prefix === 'adv') rows.advance[year] = value;
    });

    return [rows.upgrade, rows.standard, rows.advance];
};


const Substable = () => {
    const { arn: parArn, childArn } = useContext(FilterContext);

    const { data, isLoading, isError } = useQuery({
        queryKey: ['subcriptionsalecount', parArn, childArn],
        queryFn: () => fetchsubcriptionsalecount(parArn, childArn),
        enabled: !!(parArn || childArn),
        select: (res) => transformData(res?.result || {})
    });

    const columns = useMemo(() => ([
        {
            accessorKey: 'type',
            header: 'Plan',
            cell: info => {
                const value = info.getValue();
                return value;
            }
        },
        { accessorKey: '0Y', header: '0Y' },
        { accessorKey: '1Y', header: '1Y' },
        { accessorKey: '2Y', header: '2Y' },
        { accessorKey: '3Y', header: '3Y' },
    ]), []);

    const table = useReactTable({
        data: data || [],
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    if (isLoading) return <div className="p-4">Loading...</div>;
    if (isError) return <div className="p-4 text-red-500">Error loading data.</div>;

    return (
        <div className="p-3">
            <table className="min-w-full text-sm ">
                <thead>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id} className="bg-gray-300">
                            {headerGroup.headers.map(header => {
                                const headerText = header.column.columnDef.header;
                                let bgClass = '';
                                if (headerText === 'Standard') bgClass = 'bg-[#0070C0] text-white';
                                else if (headerText === 'Advance') bgClass = 'bg-green-500 text-white';
                                else if (headerText === 'Update') bgClass = 'bg-blue-500 text-white';

                                return (
                                    <th key={header.id} className={`p-2 text-left  ${bgClass}`}>
                                        {flexRender(headerText, header.getContext())}
                                    </th>
                                );
                            })}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {table.getRowModel().rows.map(row => (
                        <tr key={row.id} className="hover:bg-gray-50">
                            {row.getVisibleCells().map(cell => (
                                <td key={cell.id} className="p-2">
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Substable;
